import { render } from "./page-header.vue?vue&type=template&id=b397cbd2"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__